import { render, staticRenderFns } from "./NewsMedia.vue?vue&type=template&id=c47a424a"
import script from "./NewsMedia.vue?vue&type=script&lang=js"
export * from "./NewsMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports